module.exports = __webpack_public_path__ + "images/like-active-5f14696a.svg";